<template>
  <div>
    <transition name="fade" mode="out-in" appear>
      <Sidebar
        :isOpen="isOpen"
        :isOpenMobile="isOpenMobile"
        v-on:toggle-sidebar="toggleSideBar"
        v-on:toggle-sidebar-mobile="toggleSideBarMobile"
      />
    </transition>
    <div
      class="main-content d-flex flex-column"
      v-bind:class="{ 'hide-sidemenu-area': isOpen }"
    >
      <Header
        :isOpen="isOpen"
        :isOpenMobile="isOpenMobile"
        v-on:toggle-sidebar-mobile="toggleSideBarMobile"
      />
      <div @click="closeSideBarMobile" class="custom-layout">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '../Components/Header'
import Sidebar from '../Components/Sidebar'

export default {
  name: 'app',
  components: {
    Header,
    Sidebar
  },
  computed: {
    ...mapGetters({
      isOpen: 'dom/isOpen',
      isOpenMobile: 'dom/isOpenMobile'
    })
  },
  methods: {
    toggleSideBar () {
      this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
    },
    toggleSideBarMobile () {
      this.$store.commit('dom/SET_SIDEBAR_STATUS_MOBILE', !this.isOpenMobile)
    },
    closeSideBarMobile () {
      if (this.isOpenMobile) {
        this.$store.commit('dom/SET_SIDEBAR_STATUS_MOBILE', false)
      }
    }
  }
}
</script>

<style scoped>
.custom-layout {
  /* margin: 20px 10px 20px 10px !important; */
  margin: 20px 10px 0px 10px !important;
  background: white;
  /* border-radius: 10px; */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
  min-height: calc(100vh - 70px);
}
.main-content{
  background: #ddedff ;
}
</style>
